console.log('✅ listing-page-component.js loaded successfully!');


import { appState } from '../../js/state.js';

import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

import {  isNodeEnvironment } from '../../js/utils-fetch-data-json.js';

import {  convertDateToStringAndFormatForLanguage} from '../../js/utils-convert-numbers.js';


import {
  fetchGetRelatedBlogArticlesForBlogArticlePageByArticleID,
  fetchGetRelatedProductsForBlogArticlePageByArticleID,
  fetchGetBlogArticleForBlogArticlePage,
} from '../../services/data-services/blog-data-service.js';

import { buildComponentBlogCategoriesSide } from './blog-categories-side.js';
import { buildComponentSubscribeNewsletterWide, initbuildComponentSubscribeNewsletterWide } from '../newsletter/subscribe-newsletter-wide.js';
import { updateBlogTopNavSelectedHighlightToSelectedListeners } from './blog-top-nav.js';

export async function buildComponentBlogArticle(params) {
  console.log(
    `🔄 Building Component: buildComponentBlogArticle - lang: ${appState.SiteLanguageCookie}`
  );

    try {
        const skeleton = await buildPageSkeleton();

        registerEventListenerToAttach(async () => initbuildComponentBlogArticle(params));
       // registerEventListenerToAttach(initbuildComponentBlogArticle);


        if (!isNodeEnvironment()) return skeleton;

        return await buildActualContent(params);


  } catch (err) {
    console.error('❌ Error building buildComponentBlogArticle:', err);
    return '<div>Error loading buildComponentBlogArticle </div>';
  }
}

export async function buildPageSkeleton() {
  // Top two “featured” cards
  const topCardsSkeletonHtml = `
      <br />
    <div class="grid-blog-home-bottom-section-card my-fake-image-height-250">
        <div class="my-site-lazy-loading-card">
            <div class="my-site-lazy-loading-card-movement"></div>
        </div>
    </div>
  `;

  let middleCardsSkeleton = '';
  for (let i = 0; i < 36; i++) {
    middleCardsSkeleton += `
     <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>

                        <br />
    `;
  }

  // Sidebar section: repeat 5 times
  let sideBarCardsSkeleton = '  <br>  <br>';
  for (let i = 0; i < 5; i++) {
    sideBarCardsSkeleton += `
                <div class="grid-blog-home-bottom-section-card my-fake-image-height-125">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>

                        <br />

    `;
  }

  // Middle section: repeat 6 times
  let bottomCardsSkeleton = '';
  for (let i = 0; i < 6; i++) {
    bottomCardsSkeleton += `
     <div class="grid-blog-home-bottom-section-card my-fake-image-height-400">
                        <div class="my-site-lazy-loading-card">
                        <div class="my-site-lazy-loading-card-movement"></div>
                    </div>
                </div>
    `;
  }

  const html = `


    <div id="placeholder-buildComponentBlogArticle">

    <div class="my-blog-hero-div-wrapper">

       
    </div>

  <center>
    <div class="myPageMargins">
        <div class="blog-flex-row">

            <div class="blog-flex-column-main-content">
            <br />
            ${middleCardsSkeleton}

            </div>
             <div class="blog-flex-column-sidebar-content">
              <br /> 
                     <br /> 

             ${sideBarCardsSkeleton}

             </div>
        </div>
    </div>
</center>

    </div>




    
   
  `;

  return html;
}

export async function buildActualContent(params) {

  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translator-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  const {
    keyRecentArticles: lblRecentArticles,
    keyHome: lblHome,
    keyPostedOn: lblPostedOn,
    keyPostedBy: lblPostedBy,
    keyMinRead: lblMinRead,
    keyMinsRead: lblMinsRead,
    keyArticleNotFoundMessage: lblArticleNotFoundMessage,
    keyLastUpdated: lblLastUpdated,
    keyRelatedArticles: lblRelatedArticles,
    keyRelatedProducts: lblRelatedProducts,
  } = _tempTextTranslator;

  const { keyBlog: linkBlog } = _tempLinksTranslator;

  //params: 6,hardware,41,honeywell-xnx-gas-detector-calibration-machine-price,
  //blog/24/suppliers-and-manufacturers/43/indian-hair-the-global-demand-for-temple-hair

  //get the values from the params
  const valuesNeeded = params?.split(',') || '';
  let selectedArticleCategoryID = valuesNeeded[1];
  let categorySEOPageName = valuesNeeded[2];
  let selectedArticleID = valuesNeeded[3];

  const article = await fetchGetBlogArticleForBlogArticlePage(
    selectedArticleCategoryID,
    selectedArticleID
  );

  if (!article || article.articleID <= 0) {
    console.log('❌ Error: Article not found');
    return buildAritcleNotFoundPage(lblArticleNotFoundMessage);
  }

  //const dtAPIResultRecentArticles = await fetchGetAllRecentArticlesBlogHome();

  const dtRelatedArticles = await fetchGetRelatedBlogArticlesForBlogArticlePageByArticleID(
    selectedArticleID
  );

  const dtRelatedProducts = await fetchGetRelatedProductsForBlogArticlePageByArticleID(
    selectedArticleID
  );

  const topHeroAreaHTML = await renderTopHeroAreaHTML(article);

  const breadCrumbHTML = await renderBreadCrumbHTML(article, linkBlog, lblHome);

  const dateAndAurthorHTML = await renderDateAndAuthorHTML(
    article,
    lblPostedOn,
    lblPostedBy,
    lblMinRead,
    lblMinsRead,
    lblLastUpdated
  );

  const relatedArticlesAreaHTML = await renderRelatedArticlesAreaHTML(
    dtRelatedArticles,
    linkBlog,
    lblRelatedArticles
  );

  const relatedProductsAreaHTML = await renderRelatedProductsAreaHTML(
    dtRelatedProducts,
    lblRelatedProducts
  );

  const blogCategoriesSideForSideHTML = await buildComponentBlogCategoriesSide();

  const subscribeNewsletterWideHTML = await buildComponentSubscribeNewsletterWide();

  //const cartRowsHTML = (cartItems?.length > 0) ? await renderCartRows(dtAPIResultFeaturedArticles) : renderEmptyCart();

  //const cartBottomSummaryHTML = (cartItems?.length > 0) ? await renderCartBottomSummarySection(dtAPIResultFeaturedArticles) : "";

  const sectionToPreventTreeShaking = ` <div class="myBlogImageOwnRow myBlogImageOwnRowCenter myBlogImageInPara myBlogImageInParaImage myBlogImageSizeMedium myBlogImageFloatLeft myMainArticleParagraphHolder paraDark paraDarker paraDarkest paraBlack">
    

    <img  src="" class="myBlogImageSizeMedium">



    </div>
   

    <div class="myBlogImageReferenceDivision"> testing 1 </div>

`;

  const html = `

   

    <div class="my-blog-hero-div-wrapper">
     ${topHeroAreaHTML}      
    </div>

  <center>
    <div class="myPageMargins">
        <div class="blog-flex-row">

            <div class="blog-flex-column-main-content">
           ${breadCrumbHTML}

           
          <h1 class="BlogTitle-Main-H1-Heading">    ${article.title}  </h1>

             <div class="BlogCreatedAndUpdated-Div">

             ${dateAndAurthorHTML}
             </div>

              <div class="myMainArticleParagraphHolder">

                ${article.articleContent}

                </div>


                 <br />
                    <br />
                ${subscribeNewsletterWideHTML}

            </div>
             <div class="blog-flex-column-sidebar-content">
              

             ${relatedArticlesAreaHTML}

            ${blogCategoriesSideForSideHTML}

            ${relatedProductsAreaHTML}

             </div>
        </div>
    </div>
</center>



        `;

  return html;
}

export async function buildAritcleNotFoundPage(lblArticleNotFoundMessage) {
  const blogCategoriesSideForSide = await buildComponentBlogCategoriesSide();

  const subscribeNewsletterWideHTML = await buildComponentSubscribeNewsletterWide();

  const html = `

  

    <div class="my-blog-hero-div-wrapper">

       
    </div>

  <center>
    <div class="myPageMargins">
        <div class="blog-flex-row">

            <div class="blog-flex-column-main-content">
            <br />
            <div>
                            <br /><br /><br /><br />
                            ${lblArticleNotFoundMessage}
                            <br /><br /><br /><br />
            </div>

            <br /><br /><br /><br />
            ${subscribeNewsletterWideHTML}

            </div>
             <div class="blog-flex-column-sidebar-content">
              <br /> 
                     <br /> 


            ${blogCategoriesSideForSide}

             </div>
        </div>
    </div>
</center>


<br>
<br>
<br>
<br>
    
   
  `;

  return html;
}

export async function initbuildComponentBlogArticle(params) {
  try {
    console.log('✅ buildComponentBlogArticle event listeners attached.');


      const container = document.querySelector("#placeholder-buildComponentBlogArticle");
      if (!container) return;


      container.innerHTML = await buildActualContent(params);



      updateBlogTopNavSelectedHighlightToSelectedListeners();

     await initbuildComponentSubscribeNewsletterWide();



  } catch (error) {
    console.error('❌ Error attaching event listeners to buildComponentBlogArticle:', error);
  }
}

export async function renderTopHeroAreaHTML(article) {
  const heroUrl = article?.image2FileName || article?.image1FileName;
  const html = `<div class="my-blog-hero-div-image" style="background-image:url('${heroUrl}')"></div>

    
    `;

  return html;
}

export async function renderBreadCrumbHTML(article, linkBlog, lblHome) {
  const categoryLink = `${linkBlog}/${article.displayDefaultArticleCategoryID}/${article.displayDefaultArticleCategorySEOPageName}`;

  const html = `

       <nav aria-label="breadcrumb">

                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a href="${linkBlog}">${lblHome}</a>
                                </li>
                                <li class="breadcrumb-item">
                                    <a href="${categoryLink}">
                                        ${article.displayDefaultArticleCategoryName}
                                    </a>
                                </li>
                                <li class="breadcrumb-item breadcrumb-item-active" aria-current="page">
                                    ${article.title}
                                </li>
                            </ol>

                        </nav>

                        `;

  return html;
}

export async function renderDateAndAuthorHTML(
  article,
  lblPostedOn,
  lblPostedBy,
  lblMinRead,
  lblMinsRead,
  lblLastUpdated
) {
  //// 5) Date / author / read-time

  const date = convertDateToStringAndFormatForLanguage(
    article.dateCreated,
    'MMMM dd, yyyy',
    appState.SiteLanguageCookie
  );
  const dateLastUpdated = convertDateToStringAndFormatForLanguage(
    article.dateUpdated,
    'MMMM dd, yyyy',
    appState.SiteLanguageCookie
  );

  const postDateFrag = article.authorName
    ? `  <span class="articlePostDate">   ${lblPostedBy} ${article.AuthorName} on    ${lblPostedOn}  ${date}                         </span>`
    : `<span class="articlePostDate">            ${lblPostedOn}  ${date}        </span>`;

  const readTimeFrag =
    article.readTime === 1
      ? `  <span class="articleLastUpDated">       ${article.readTime}  ${lblMinRead}   </span>`
      : `  <span class="articleLastUpDated">       ${article.readTime}  ${lblMinsRead}   </span>`;

  const lastUpdated =
    article.dateUpdated > article.dateCreated
      ? `<span class="articleLastUpDated">Last updated: ${lblPostedOn} ${dateLastUpdated}</span>`
      : '';

  const html = `

        ${postDateFrag}
        ${readTimeFrag}
        ${lastUpdated}
      

                        `;

  return html;
}

export async function renderRelatedArticlesAreaHTML(
  dtRelatedArticles,
  linkBlog,
  lblRelatedArticles
) {
  const relatedArticlesData = dtRelatedArticles || [];

  const listOfHTMLRows = relatedArticlesData
    .map(item => {
      const currentNavLink = `${linkBlog}/${item.defaultArticleCategoryID}/${item.defaultArticleCategorySEOPageName}/${item.articleID}/${item.seoPageName}`;

      const date = convertDateToStringAndFormatForLanguage(
        item.dateCreated,
        'MMMM dd, yyyy',
        appState.SiteLanguageCookie
      );

      const container = `

           <a href="${currentNavLink}">
                                <div class="my-blog-article-related-article-side-nav-link">
                                    <div class="my-blog-article-related-article-side-nav-title">
                                         ${item.title}

                                    </div>
                                    <div class="my-blog-article-related-article-side-nav-date">
                                      ${date} 
                                    </div>
                                </div>
                            </a>



                `;

      return container;
    })
    .join('');

  const mainResultHTML = `

      <div class="sideBarTopPaddingDiv"></div>

        <div class="my-blog-article-related-article-side-nav-Wrapper">

        <h3>${lblRelatedArticles}</h3>
        ${listOfHTMLRows}

        </div>
        `;

  const html = `${
    relatedArticlesData.length > 0
      ? `${mainResultHTML}`
      : `<div class="sideBarTopPaddingDiv"></div>`
  }`;

  return html;
}

export async function renderRelatedProductsAreaHTML(dtRelatedProducts, lblRelatedProducts) {
  const relatedProductsData = dtRelatedProducts || [];

  const listOfHTMLRows = relatedProductsData
    .map(item => {
      const currentNavLink = `${appState.SiteLanguageCookie}/${item.defaultProductDepartmentID}/${item.defaultProductDepartmentSEOPageName}/${item.defaultProductCategoryID}/${item.defaultProductCategorySEOPageName}/${item.productID}/${item.seoPageName}`;

      const container = `

           <a href="${currentNavLink}">
                                <div class="my-blog-article-related-article-side-nav-link">
                                    <div class="my-blog-article-related-article-side-nav-title">
                                         ${item.name}

                                    </div>
                                    <div class="my-blog-article-related-article-side-nav-date">
                                      ${item.name} 
                                    </div>
                                </div>
                            </a>



                `;

      return container;
    })
    .join('');

  const mainResultHTML = `

      

        <div class="my-blog-article-related-article-side-nav-Wrapper">

        <h3>${lblRelatedProducts}</h3>
        ${listOfHTMLRows}

        </div>
        `;

  const html = `${relatedProductsData.length > 0 ? `${mainResultHTML}` : ''}`;

  return html;
}

export async function buildComponentBlogArticleHeaderTags(params) {
  
  const [{ fetchGetBlogArticleSEOTagsByArticleIDAndDefaultArticleCategoryID }] = await Promise.all([
    import(
      /* webpackChunkName:"blog-data-service", webpackPrefetch: true */ '../../services/data-services/seo-data-service.js'
    ),
  ]);


  let result = '';

  //get the values from the params
  const valuesNeeded = params?.split(',') || '';
  let selectedArticleCategoryID = valuesNeeded[1];
  let categorySEOPageName = valuesNeeded[2];
  let selectedArticleID = valuesNeeded[3];

  const currentPageSEOAPIResult = await fetchGetBlogArticleSEOTagsByArticleIDAndDefaultArticleCategoryID(
    selectedArticleID,
    selectedArticleCategoryID
  );

  //alert("currentPageSEOAPIResult: " + JSON.stringify(currentPageSEOAPIResult));

  if (!currentPageSEOAPIResult) {
    console.log('❌ Error: seo Blog Article not found');

    return result;
  }

  result = currentPageSEOAPIResult;

  return result;
}
